export class RootURL {
  //static ApiBase = window.location.origin;
  //  static ApiBase = "https://test-tiktok.orichi.info";
  static ApiBase = "https://tiktok.orichi.info";
  // static ApiBase = "https://localhost:44341";
}
